// extracted by mini-css-extract-plugin
module.exports = {"base":"base-3okvJ","small":"small-fqb6C","large":"large-2dJnB","primary":"primary-20kTc","secondary":"secondary-3WMiQ","neitral":"neitral-2h3I7","outlined":"outlined-nhv81"};